const STORE_PHOTO = "https://customer-assets-0z36b82j.emergentagent.net/job_sandar-eats/artifacts/v4xitkzq_Sandar%20Sushi%20Store.PNG";

export default function Story() {
  return (
    <div>
      {/* Hero */}
      <section className="relative h-[420px] overflow-hidden">
        <img src={STORE_PHOTO} alt="Sandar Sushi storefront" className="absolute inset-0 w-full h-full object-cover"/>
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-black/20"/>
        <div className="absolute bottom-10 left-0 right-0 max-w-7xl mx-auto px-6 lg:px-10">
          <p className="eyebrow text-white/80 mb-3">Our Story</p>
          <h1 className="font-display font-bold text-5xl lg:text-6xl text-white tracking-tight" data-testid="story-title">
            From Service<br/><span className="text-[hsl(var(--primary))]">to Sandar Sushi.</span>
          </h1>
        </div>
      </section>

      {/* Two-column: photo left, story text right */}
      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-16 lg:py-20">
        <div className="grid lg:grid-cols-5 gap-10 lg:gap-14 items-start">
          {/* Photo — left, sticky on desktop */}
          <div className="lg:col-span-2 order-1">
            <div className="lg:sticky lg:top-24">
              <div className="relative">
                <div className="absolute -inset-3 rounded-3xl bg-[hsl(var(--primary))]/15 blur-2xl -z-10" />
                <img
                  src={STORE_PHOTO}
                  alt="Inside a Sandar Sushi location"
                  className="w-full h-auto rounded-3xl shadow-xl ring-1 ring-black/5"
                  data-testid="story-photo"
                />
              </div>
            </div>
          </div>

          {/* Text — right */}
          <div className="lg:col-span-3 order-2 space-y-6 text-neutral-700 leading-relaxed" data-testid="story-content">
            <p className="text-xl sm:text-2xl leading-relaxed text-neutral-900 font-display" data-testid="story-lead">
              For Sandar Sushi founder <span className="text-[hsl(var(--primary))] font-semibold">Win Htun</span>, serving the military community is personal.
            </p>
            <p className="text-neutral-600">
              As an Army veteran, he understands the pace of life on a military installation: schedules are full, breaks are short, and a good meal can make a difference.
            </p>
            <p>
              Win founded Sandar Sushi with a simple idea: people should be able to find fresh, satisfying food where they work and serve. He brought sushi and convenient Asian-inspired meals to military installations, building a menu that now includes poke bowls, rice bowls, dumplings, bao, and ramen.
            </p>
            <p>
              Growing Sandar Sushi across multiple locations has meant paying close attention to what customers need and to the people who prepare their food. Win's goal is simple: for anyone stopping in between responsibilities to find a meal made with care and a team that is genuinely glad to serve them.
            </p>
            <p>
              His military service is part of Sandar Sushi's story, but so is the work that happens every day: preparing fresh food, welcoming customers, and earning their trust one meal at a time.
            </p>

            {/* Pull quote */}
            <blockquote className="mt-6 rounded-2xl bg-neutral-950 text-white p-8 relative overflow-hidden" data-testid="story-pullquote">
              <div className="absolute -right-8 -top-8 w-40 h-40 rounded-full bg-[hsl(var(--primary))]/20"/>
              <div className="absolute right-16 -bottom-6 w-24 h-24 rounded-full bg-[hsl(var(--primary))]/10"/>
              <p className="relative font-display text-2xl sm:text-3xl leading-tight">
                Sandar Sushi is Win's way of continuing to serve the community that helped shape him.
              </p>
            </blockquote>

            {/* Pillars */}
            <div className="grid sm:grid-cols-3 gap-4 pt-4">
              {[
                { k: "Simple", d: "Clean, honest flavors, prepared with skill." },
                { k: "Fresh", d: "Sourced and rolled the same day, every day." },
                { k: "Made with care", d: "By a team that's proud to serve their community." },
              ].map(({ k, d }) => (
                <div key={k} className="p-5 rounded-2xl bg-white border border-neutral-200/70">
                  <div className="font-display font-bold text-xl text-[hsl(var(--primary))]">{k}.</div>
                  <p className="text-sm text-neutral-500 mt-1.5">{d}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
